export default __webpack_public_path__ + "static/media/Ellipse.a61cb5a3.svg";